(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["k0-prototype"] && !Shopify.designMode) return;
  try {
    
  /* K-0 PROTOTYPE：サムネイルを押すと主写真を差し替える */
  (function () {
    if (window.customElements.get('k0-gallery')) return;
    class K0Gallery extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', function (event) {
          var thumb = event.target.closest('[data-k0-thumb]');
          if (!thumb || !this.contains(thumb)) return;
          var main = this.querySelector('[data-k0-main]');
          var tpl = thumb.querySelector('template');
          if (!main || !tpl) return;
          main.replaceChildren(tpl.content.cloneNode(true));
          this.querySelectorAll('[data-k0-thumb]').forEach(function (el) {
            el.setAttribute('aria-current', el === thumb ? 'true' : 'false');
          });
        });
      }
    }
    window.customElements.define('k0-gallery', K0Gallery);
  })();

  } catch(e) { console.error(e); }
})();
})();
